var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightInputArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 27,
    viewBox: "0 0 15 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07512 26.1483C1.93805 27.0853 3.332 27.0853 4.19492 26.1483L14.3509 15.1196C15.2138 14.1825 15.2138 12.6688 14.3509 11.7317L4.19492 0.703025C3.332 -0.234052 1.93805 -0.234052 1.07513 0.703024C0.212204 1.6401 0.212204 3.15384 1.07513 4.09092L9.6601 13.4377L1.07513 22.7604C0.212202 23.6974 0.234328 25.2352 1.07512 26.1483Z",
    fill: "#ED1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightInputArrowIcon);
export default __webpack_public_path__ + "static/media/right_input_arrow_icon.24cd85f050f1fe742051a1b0fb1e1a36.svg";
export { ForwardRef as ReactComponent };